import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getBoardColorLabel, getColorsForBoard } from './boards.helpers';

function BoardCardColorLabel({
  boardId,
  color,
  textColor,
  className,
}) {
  const boardColors = useSelector((state) => getColorsForBoard(boardId, {
    selectedBoard: state.boards.selectedBoard,
    boardDetailsMap: state.boards.boardDetailsMap,
    boardColors: state.boards.boardColors,
  }));

  const label = useMemo(
    () => getBoardColorLabel(color, boardColors),
    [color, boardColors],
  );

  if (!label) return null;

  return (
    <span
      className={['board-card-color-label', className].filter(Boolean).join(' ')}
      style={textColor ? { color: textColor } : undefined}
      title={label}
    >
      {label}
    </span>
  );
}

BoardCardColorLabel.propTypes = {
  boardId: PropTypes.string.isRequired,
  color: PropTypes.string,
  textColor: PropTypes.string,
  className: PropTypes.string,
};

BoardCardColorLabel.defaultProps = {
  color: null,
  textColor: null,
  className: null,
};

export default BoardCardColorLabel;
